import userStore, { UserStore } from './userStore'

let localStore: Storage | UserStore
try {
  localStore = localStorage || userStore
} catch (err) {
  localStore = userStore
}
export default class History {
  name: string

  constructor(name: string) {
    this.name = name
  }

  push(log: string) {
    if (!log) return
    try {
      const previous = localStore.getItem(this.name)
      localStore.setItem(this.name, previous ? previous + ',' + log : log)
    } catch (error) {
      console.log('localstorage or userData is disabled!')
    }
  }

  length(): number {
    try {
      const logs = localStore.getItem(this.name) || ''
      return logs ? logs.split(',').length : 0
    } catch (error) {
      console.log('localstorage or userData is disabled!')
      return 0
    }
  }

  pop(len: number = 1): string[] {
    let poped: string[]
    try {
      const value = localStore.getItem(this.name)
      const logs = value ? value.split(',') : []
      poped = logs.splice(0, len)
      localStore.setItem(this.name, logs.join(','))
    } catch (error) {
      poped = []
      console.log('localstorage or userData is disabled!')
    }
    return poped
  }

  clear() {
    try {
      localStore.removeItem(this.name)
    } catch (error) {
      console.log('localstorage or userData is disabled!')
    }
  }
}
